import { BookingResponseJson } from '@/types/Booking'
import { useTranslations } from 'next-intl'
import React from 'react'

export function GetOrUpdateBookingError(props: { bookingData: BookingResponseJson }) {
  const t = useTranslations('Booking.GetOrUpdateBookingError')
  return (
    <div>
      <p>{props.bookingData.StatusText}</p>
      <p>
        <a href="/search">{t('updateBookingErrorTitle')}</a>
      </p>
    </div>
  )
}
